import React, { forwardRef } from 'react';

/**
 * @typedef {Object} FlexProps
 * @property {React.CSSProperties['flexDirection']} [direction]
 * @property {React.CSSProperties['alignItems']} [align]
 * @property {React.CSSProperties['justifyContent']} [justify]
 * @property {React.CSSProperties['gap']} [gap]
 * @property {React.CSSProperties['flexWrap']} [wrap]
 * @property {string} [className]
 * @property {React.CSSProperties} [style]
 * @property {React.ReactNode} [children]
 * @property {string} [role]
 * @property {string} [aria-label]
 * @property {string} [title]
 */

/** @type {React.ForwardRefExoticComponent<FlexProps & React.RefAttributes<HTMLDivElement>>} */
export const Flex = forwardRef(function Flex(props, ref) {
  const {
    direction = 'row',
    align = 'stretch',
    justify = 'flex-start',
    gap,
    wrap = 'nowrap',
    className = '',
    style,
    children,
    ...rest
  } = props;
  const mergedStyle = {
    display: 'flex',
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    gap,
    ...style,
  };

  return (
    <div
      className={`flex ${className}`.trim()}
      style={mergedStyle}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
});
